/**
 * Mints the idempotency key for one outgoing message.
 *
 * Called exactly once, when the agent presses Send, and the value is replayed verbatim on
 * every retry. That is the entire safety property of the outbox: an agent on a flaky link
 * will retry a send whose response was lost, and without a stable key the desk receives
 * the same instruction twice.
 *
 * `crypto.randomUUID` is undefined on insecure origins, and agents do reach this app over
 * plain HTTP — so the guarded fallback is not defensive padding, it is the branch that
 * actually runs on some devices. Same shape as usePulseEventMachine's referenceId
 * (hooks/usePulseEventMachine.ts:209-212), deliberately, so there is one idiom to audit.
 *
 * The fallback is not cryptographically random and does not need to be: this is a dedupe
 * key scoped to one user's own queue, never a token or a secret.
 */
export const mintClientId = (): string =>
	typeof crypto !== 'undefined' && 'randomUUID' in crypto
		? crypto.randomUUID()
		: `${Date.now()}-${Math.random().toString(36).slice(2)}`;
